import * as React from "react";
import { cn } from "@/lib/utils";

// Deck input: white surface, hairline border, radius 10, brand focus ring.
const Input = React.forwardRef(({ className, type, ...props }, ref) => (
  <input
    type={type}
    ref={ref}
    data-kit=""
    className={cn(
      "flex h-10 w-full rounded-sm border border-input bg-card px-3.5 py-2 text-sm text-foreground shadow-sm transition-colors",
      "placeholder:text-muted-foreground",
      "focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/20",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "file:border-0 file:bg-transparent file:text-sm file:font-medium",
      className
    )}
    {...props}
  />
));
Input.displayName = "Input";

export { Input };
